import React from 'react';
import ForaneParishSelector from './ForaneParishSelector';

function ChurchReportPage() {
  return (
    <div className="container mx-auto py-8">
      <ForaneParishSelector />
    </div>
  );
}

export default ChurchReportPage;